export default {
  "logoLink": "https://www.atfx.com/de",       //修改该参数请在/static/lang.js也需修改
  "FCA_License_No": "FCA Lizenznummer",     //修改该参数请在/static/lang.js也需修改
  "headTtitle": "Eröffnen Sie ein Live Forex- & CFD-Handelskonto | ATFX UK",//修改该参数请在/static/lang.js也需修改
  "topFixedBanner": "Spread-Wetten und CFDs sind komplexe Instrumente und bergen aufgrund der Hebelwirkung ein hohes Risiko, schnell Geld zu verlieren. Die große Mehrheit der Konten von Kleinanlegern verliert Geld beim Handel mit CFDs. Sie sollten abwägen, ob Sie es sich leisten können, das hohe Risiko einzugehen, Ihr Geld zu verlieren.",//修改该参数请在/static/lang.js也需修改
  "topFixedBannerShort": "59.38% der Kleinanlegerkonten verlieren Geld beim CFD-Handel mit diesem Anbieter.",//修改该参数请在/static/lang.js也需修改
  "headDescription": "Eröffnen Sie ein ATFX Forex- und CFD Live-Konto bei einem Broker, der von der UK FCA reguliert wird. Kleine Spreads, ein Hebel von bis zu 1:200, MT4-Handelsplattform, 24/5 Kundendienst. Melden Sie sich jetzt an!",
  "policyBarClose": 'Das Unternehmen hat beschlossen, die Erbringung von Dienstleistungen für Privatkunden mit sofortiger Wirkung einzustellen. Wir können daher keine Bewerbungen annehmen.<br />Dienstleistungen für professionelle Kunden werden nicht beeinträchtigt. Für professionelle Bewerbungen wenden Sie sich bitte an <a href="mailto:cs.uk@atfx.com">cs.uk@atfx.com</a>',
  "policyBar":'Wir verwenden Cookies, um Ihnen das beste Nutzererlebnis auf unserer Website zu bieten. Indem Sie mit dem Besuch dieser Website fortfahren, akzeptieren Sie unsere Verwendung von Cookies. <a title="[Weiterlesen] " href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Cookies%20Policy%20EN.pdf" target="_blanck">[Weiterlesen] </a>',
  "policyBarButton":'Akzeptieren',
  "header": {
    "registration": "Kontoeröffnung",
    "personalDetails1": "Personenbezogene Daten 1",
    "personalDetails2": "Personenbezogene Daten 2",
    "financialDetails": "Finanzinformationen",
    "Experience": "Erfahrung",
    "Knowledge": "Wissen",
    "Acknowledgements": "Bestätigungen",
    "previewPage": "Vorschau",
    "liveTrading": "Live-Handel"
  },
  "footer":{ //修改该参数请在/static/lang.js也需修改
    "copyright":"© 2020 ATFX.COM. Alle Rechte vorbehalten.",
    "terms1":'<a href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Privacy%20Notice%20EN%2031.08.pdf" target="_blank" rel="noopener">Datenschutzrichtlinien</a>',
    "terms2":'<a href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Cookies%20Policy%20EN.pdf" target="_blank" rel="noopener">Cookie Richtlinien</a>',
    "terms3":'<a href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Standard%20Terms%20of%20Business%20EN%20-%20V08.18.pdf" target="_blank" rel="noopener">Allgemeine Geschäftsbedingungen</a>',
    "Legal":"Rechtliches: AT Global Markets (UK) Limited ist bei der Financial Conduct Authority (FCA) zugelassen und unterliegt deren Regulierung. FCA-Zulassungsnummer (760555). Eingetragener Firmensitz: 1st Floor, 32 Cornhill, London EC3V 3SG. United Kingdom Unternehmensnummer 09827091",
    "riskWaring":'WARNUNG VOR INVESTITIONEN MIT HOHEM RISIKO: CFDs sind komplexe Instrumente und gehen wegen der Hebelwirkung mit dem hohen Risiko einher, schnell Geld zu verlieren. <strong>59.38% der Kleinanlegerkonten verlieren Geld beim CFD-Handel mit diesem Anbieter. </strong>Sie sollten sich überlegen, ob Sie verstehen, wie CFDs funktionieren und ob Sie es sich leisten können, das hohe Risiko einzugehen, Ihr Geld zu verlieren. <a title="Risk Disclosure Policy" href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Standard%20Terms%20of%20Business%20EN%20-%20V08.18.pdf" target="_blanck">Bitte lesen Sie die vollständigen Risikorichtlinien.</a>.',
    "otherInfo":"Die Informationen auf dieser Website richten sich nicht an Einwohner der Vereinigten Staaten von Amerika, Belgien oder eines anderen Landes außerhalb des Vereinigten Königreichs. Die Informationen sind nicht zur Weitergabe an oder zur Verwendung durch Personen in einem Land oder Rechtsraum bestimmt, in dem eine solche Verbreitung oder Verwendung den lokalen Gesetzen oder Vorschriften entgegensteht."
  },
  "headerMsg": {
    "personalDetails1": "Mit der Übermittlung dieser Informationen bestätige ich, dass ich den <a href='https://www.atfx.com/uk/wp-content/uploads/standard-terms-uk-en.pdf' target='_blank'>Allgemeinen Geschäftsbedingungen</a> und der <a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Privacy%20Notice%20EN%2031.08.pdf' target='_blank'>Datenschutzrichtlinie</a> von ATFX zustimme und hinsichtlich meines Antrags kontaktiert werden kann.",
    "personalDetails2": "Mit der Übermittlung dieser Informationen bestätige ich, dass ich den <a href='https://www.atfx.com/uk/wp-content/uploads/standard-terms-uk-en.pdf' target='_blank'>Allgemeinen Geschäftsbedingungen</a> und der <a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Privacy%20Notice%20EN%2031.08.pdf' target='_blank'>Datenschutzrichtlinie</a> von ATFX zustimme und hinsichtlich meines Antrags kontaktiert werden kann.",
    "financialDetails": "Als eine durch die FCA regulierte Firma sind wir verpflichtet zu beurteilen, ob unsere Produkte für Sie geeignet sind. Die von Ihnen angegebenen Antworten bestimmen, ob wir Ihnen unsere Dienste anbieten können.",
    "experience": "Als eine durch die FCA regulierte Firma sind wir verpflichtet zu beurteilen, ob unsere Produkte für Sie geeignet sind. Die von Ihnen angegebenen Antworten bestimmen, ob wir Ihnen unsere Dienste anbieten können.",
    "knowledge": "Als eine durch die FCA regulierte Firma sind wir verpflichtet zu beurteilen, ob unsere Produkte für Sie geeignet sind. Die von Ihnen angegebenen Antworten bestimmen, ob wir Ihnen unsere Dienste anbieten können.",
    "acknowledgements": "Mit dem Ausfüllen dieses Antrags bestätigen Sie, dass Sie verstanden haben, dass FX und CFDs mit Margin gehebelte Produkte sind und ein hohes Risiko für Ihr investiertes Kapital darstellen. Sie bestätigen weiterhin, dass es in Ihrer Verantwortung liegt, Ihr Konto zu überwachen."
  },
  "changeLanguage": "Sprache ändern",
  "back": "Zurück",
  "next": "Weiter",
  "finish": "Beenden",
  "personalDetails1": {
    "estimatedTime":"Die voraussichtliche Zeit für die Registrierung beträgt 5 Minuten",
    "Gender": "Geschlecht",
    "genderSelect": {
      "M": "Männlich",
      "F": "Weiblich",
      "O": "Andere"
    },
    "OtherGender": "Anderes Geschlecht",
    "Title": "Titel",
    "titleSelect": {
      "Mr": "Herr",
      "Ms": "Frau",
      "Dr": "Dr.",
      "Other": "Andere",
    },
    "OtherTitle": "Anderer Titel",
    "First_Name": "Vorname",
    "Surname": "Nachname",
    "Email": "E-Mail",
    "Email_Confirm": "E-Mail bestätigen",
    "Lang": "E-Mail-Sprache",
    "emailLanguages": {
      "ENG": "Englisch",
      "CHT": "Traditionelles Chinesisch",
      "CHS": "Vereinfachtes Chinesisch",
      "ARA": "Arabisch",
      "ESP": "Spanisch",
      "ITA": "Italienisch",
      "GER": "Deutsch",
      "PTG": "Portugees"
    },
    "MT4_Currency": "Handelskontowährung",
    "MT4CurrencySelect": {
      "USD": "(USD) Dollar",
      "GBP": "(GBP) Pfund",
      "EUR": "(EUR) Euro"
    },
    "Account_Type": "Kontotyp",
    "Account_TypeSelect": {
      "CFDs": "CFDs",
      "SpreadBetting":"Spread-Wetten"
    },
    "Country": "Land des Wohnsitzes",
    "countrySelect": {
      "USA": "United States of America",
      "HKG": "Hong Kong",
      "GBR": "Großbritannien",
      "CHN": "China",
      "TWN": "Taiwan",
      "ARE": "Vereinigte Arabische Emirate",
      "ALB": "Albanien",
      "AND": "Andorra",
      "AIA": "Anguilla",
      "ATG": "Antigua und Barbuda",
      "ARG": "Argentinien",
      "ARM": "Armenien",
      "ABW": "Aruba",
      "AUS": "Australien",
      "AUT": "Österreich",
      "AZE": "Aserbaidschan",
      "BHS": "Bahamas",
      "BHR": "Bahrain",
      "BGD": "Bangladesch",
      "BRB": "Barbados",
      "BLR": "Weißrussland",
      "BEL": "Belgien",
      "BLZ": "Belize",
      "BEN": "Benin",
      "BMU": "Bermudas",
      "BOL": "Bolivien",
      "BWA": "Botswana",
      "BVT": "Bouvetinsel",
      "BRA": "Brasilien",
      "BRN": "Brunei Darussalam",
      "BGR": "Bulgarien",
      "BFA": "Burkina Faso",
      "BDI": "Burundi",
      "KHM": "Kambodscha",
      "CMR": "Kamerun",
      "CPV": "Kap Verde",
      "CYM": "Cavman Inseln",
      "CAF": "Zentralafrikanische Republik",
      "TCD": "Tschad",
      "CHL": "Chile",
      "CCK": "Kokosinseln",
      "COL": "Kolumbien",
      "COM": "Komoren",
      "COK": "Cookinseln",
      "CRI": "Costa Rica",
      "CIV": "Elfenbeinküste",
      "HRV": "Kroatien",
      "CUB": "Kuba",
      "CYP": "Zypern",
      "CZE": "Tschechien",
      "DNK": "Dänemark",
      "DJI": "Dschibuti",
      "DMA": "Dominica",
      "DOM": "Dominikanische Republik",
      "EGY": "Ägypten",
      "SLV": "El Salvador",
      "ERI": "Eritrea",
      "EST": "Estland",
      "ETH": "Äthiopien",
      "FJI": "Fidschi",
      "FIN": "Finnland",
      "FRA": "Frankreich",
      "PYF": "Französisch Polynesien",
      "GAB": "Gabun",
      "GEO": "Georgien",
      "DEU": "Deutschland",
      "GHA": "Ghana",
      "GIB": "Gibraltar",
      "GRC": "Griechenland",
      "GRL": "Grönland",
      "GRD": "Grenada",
      "GLP": "Guadeloupe",
      "GTM": "Guatemala",
      "GIN": "Guinea",
      "GNB": "Guinea-Bissau",
      "HTI": "Haiti",
      "HMD": "Heard- und McDonald-Inseln",
      "HND": "Honduras",
      "HUN": "Ungarn",
      "ISL": "Island",
      "IND": "Indien",
      "IDN": "Indonesien",
      "IRL": "Irland",
      "ISR": "Israel",
      "ITA": "Italien",
      "JAM": "Jamaika",
      "JPN": "Japan",
      "JOR": "Jordanien",
      "KAZ": "Kasachstan",
      "KEN": "Kenia",
      "KIR": "Kiribati",
      "KOR": "Südkorea",
      "KWT": "Kuwait",
      "KGZ": "Kirgisistan",
      "LVA": "Lettland",
      "LSO": "Lesotho",
      "LBR": "Liberia",
      "LBY": "Libyen",
      "LIE": "Liechtenstein",
      "LTU": "Litauen",
      "LUX": "Luxemburg",
      "MAC": "Macao",
      "MDG": "Madagaskar",
      "MWI": "Malawi",
      "MYS": "Malaysia",
      "MDV": "Malediven",
      "MLI": "Mali",
      "MLT": "Malta",
      "MHL": "Marshallinseln",
      "MTQ": "Martinique",
      "MUS": "Mauritius",
      "MYT": "Mayotte",
      "MEX": "Mexiko",
      "MDA": "Moldawien",
      "MCO": "Monaco",
      "MNG": "Mongolei",
      "MNE": "Montenegro",
      "MSR": "Montserrat",
      "MAR": "Marokko",
      "MOZ": "Mosambik",
      "NAM": "Namibia",
      "NRU": "Nauru",
      "NLD": "Niederlande",
      "NCL": "Neu-Kaledonien",
      "NZL": "Neuseeland",
      "NIC": "Nicaragua",
      "NER": "Niger",
      "NGA": "Nigeria",
      "NIU": "Niue",
      "NFK": "Norfolkinsel",
      "NOR": "Norwegen",
      "OMN": "Oman",
      "PAK": "Pakistan",
      "PSE": "Palästina",
      "PRY": "Paraguay",
      "PER": "Peru",
      "PHL": "Philippinen",
      "PCN": "Pitcairn",
      "POL": "Polen",
      "PRT": "Portugal",
      "QAT": "Katar",
      "ROU": "Rumänien",
      "RUS": "Russland",
      "RWA": "Ruanda",
      "SHN": "St. Helena",
      "KNA": "St. Kitts und Nevis",
      "LCA": "St. Lucia",
      "SPM": "Saint Pierre und Miquelon",
      "VCT": "St. Vincent und die Grenadinen",
      "WSM": "Samoa",
      "SMR": "San Marino",
      "STP": "Sao Tome und Principe",
      "SAU": "Saudi Arabien",
      "SEN": "Senegal",
      "SRB": "Serbien",
      "SYC": "Saychellen",
      "SLE": "Sierra Leone",
      "SGP": "Singapur",
      "SVK": "Slowakei",
      "SVN": "Slowenien",
      "ZAF": "Südafrika",
      "ESP": "Spanien",
      "SUR": "Suriname",
      "SJM": "Svalbard und Jan Mayen",
      "SWZ": "Swasiland",
      "SWE": "Schweden",
      "CHE": "Schweiz",
      "TJK": "Tadschikistan",
      "TZA": "Tansania",
      "THA": "Thailand",
      "TLS": "Timor-Leste",
      "TGO": "Togo",
      "TON": "Tonga",
      "TTO": "Trinidad und Tobago",
      "TUN": "Tunesien",
      "TUR": "Türkei",
      "TKM": "Turkmenistand",
      "TCA": "Turks- und Caicoinseln",
      "TUV": "Tuvalu",
      "UKR": "Ukraine",
      "URY": "Uruguay",
      "UZB": "Usbekistan",
      "VUT": "Vanuatu",
      "VAT": "Vatikan",
      "VEN": "Venezuela",
      "VNM": "Vietnam",
      "WLF": "Wallis und Futuna",
      "ESH": "Westsahara",
      "ZMB": "Sambia",
      "DZA": "Algerien",
      "AGO": "Angola",
      "BIH": "Bosnien-Herzegowina",
      "GMB": "Gambia",
      "GUY": "Guyana",
      "IRQ": "Irak",
      "RKS": "Kosovo",
      "LBN": "Libanon",
      "MKD": "Mazedonien",
      "NPL": "Nepal",
      "PAN": "Panama",
      "PNG": "Papua Neu-Guinea",
      "LKA": "Sri Lanka"
    }
  },
  "personalDetails2": {
    "Addr": "Adresszeile 1",
    "Addr2": "Adresszeile 2",
    "City": "Stadt",
    "Postcode": "Postleitzahl",
    "Building_Name": "Hausnummer/Gebäudename",
    "Street": "Straße",
    "Province": "Region",
    "birthDate": "Geburtsdatum",
    "birthYear": "Jahr",
    "birthMonth": "Monat",
    "birthSecond": "Tag",
    "Nationality": "Staatsangehörigkeit",
    "isHavePass": "Haben Sie einen Reisepass?",
    "PotSelect": {
      "havePot": "Ja",
      "noPot": "Nein"
    },
    "NAT_ID": "Reisepassnummer",
    "Phone": "Mobiltelefon",
    "countryPlace": "Land des Steuerwohnsitzes",
    "TIN": "TIN (Steueridentifikationsnummer)",
    "Doc_Type": "Ausweistyp",
    "idTypeSelect": {
      "POT": "Reisepass",
      "IDC": "Personalausweis",
      "DRI": "Führerschein"
    },
    "Doc_No": "Ausweisnummer",
    "bankCardType": "Bankkartentyp",
    "bankCardTypeSelect": {
      "DR": "Debitkarte",
      "CR": "Kreditkarte"
    },
    "Addr_Country": "Adresse im Land",
    "Bank_Card_No": "Banknummer",
    "bankCardNoConfirm": "Bestätigung der Banknummer",
    "Bank": "Bank",
    "bankSelect": {
      "ICBK": "INDUSTRIAL AND COMMERCIAL BANK OF CHINA",
      "ABOC": "AGRICULTURAL BANK OF CHINA",
      "PCBC": "CHINA CONSTRUCTION BANK CORPORATION",
      "BKCH": "BANK OF CHINA LIMITED",
      "CMBC": "CHINA MERCHANTS BANK",
      "COMM": "BANK OF COMMUNICATIONS",
      "MSBC": "CHINA MINSHENG BANKING CORPORATION, LIMITED",
      "EVER": "CHINA EVERBRIGHT BANK",
      "SPDB": "SHANGHAI PUDONG DEVELOPMENT BANK",
      "FJIB": "INDUSTRIAL BANK",
      "CIBK": "CITIC BANK CORPORATION LIMITED",
      "PSBC": "POSTAL SAVINGS BANK OF CHINA",
      "SZCB": "SHENZHEN DEVELOPMENT BANK CO., LTD",
      "GDBK": "CHINA GUANGFA BANK",
      "BOSH": "BANK OF SHANGHAI",
      "BJCN": "BANK OF BEIJING",
      "HXBK": "HUA XIA BANK",
      "other": "ANDERE"
    },
    "OtherBank": "Andere Banken",
    "Beneficiary_Name": "Name des Begünstigten",
    "SWIFT_Code": "SWIFT-Code der Bank",
    "Branch_Name": "Name der Filiale",
    "Bank_Addr": "Adresse der Filiale",
    "Branch_Province": "Bundesland der Filiale",
    "Branch_City": "Stadt der Filiale",
    "bankCardImg": "Foto der Bankkarte",
    "IBAN_Code": "IBAN",
    "docFrontImgword": "Bild des Ausweises (Vorderseite)",
    "docBackImgword": "Bild des Ausweises (Rückseite)",
    "addressUpload": "Nachweis der Adresse",
    "addressUpload2": "Nachweis der Adresse 2",
    "addressUploadTxt1": "möglicher Nachweis: Stromrechnung / Gasrechnung / Kontoauszug / Aufenthaltserlaubnis / Führerschein / Hukou, die nicht älter als 3 Monate sein dürfen (wenn der Antragsteller nicht das Haushaltsoberhaupt ist, muss dieser in die Bilder der 1-seitigen Einreichung eingebunden werden);",
    "addressUploadTxt2": "Der Adressnachweis darf nicht mit dem Identitätsnachweis identisch sein.",
    "docImgword1": "Dokumentenanhang 1",
    "docImgword2": "Dokumentenanhang 2",
    "docImgword3": "Dokumentenanhang 3",
    "docImgword4": "Dokumentenanhang 4",
    "docImgword5": "Dokumentenanhang 5",
    "fileUpload": {
      "imgtUpload": "hochladen",
      "uploadFileArr": [{
        "labelTxt": "ID-Bild 1",
        "ValidateNull": "Bitte auswählen",
        "sizeLimit": "Das ID-Bild 1 darf 5 MB nicht überschreiten!"
      }, {
        "labelTxt": "ID-Bild 2",
        "ValidateNull": "Bitte auswählen",
        "sizeLimit": "Das ID-Bild 2 darf 5 MB nicht überschreiten!"
      }, {
        "labelTxt": "Adressnachweis",
        "ValidateNull": "Bitte auswählen",
        "sizeLimit": "Der Adressnachweis darf 5 MB nicht überschreiten!"
      }, {
        "labelTxt": "Adressnachweis 2",
        "ValidateNull": "Bitte auswählen",
        "sizeLimit": "Der Adressnachweis darf 5 MB nicht überschreiten!"
      }, {
        "labelTxt": "Andere Dateien",
        "ValidateNull": "Bitte auswählen",
        "sizeLimit": "Andere Dateien dürfen 5 MB nicht überschreiten!"
      }],
      "addressUploadHtml": {
        "sizeLimit":"Die Datei darf 5MB nicht überschreiten",
        "upload_your_documents":"Laden Sie Ihre Ausweisdokumente hoch",
        "documents_not_ready":"DOKUMENTE NICHT BEREIT?",
        "noe": "*Antragsteller müssen das ID-Bild und den Adressnachweis vorlegen, um ihre Identität zu verifizieren.",
        "noe2":"Sie können Ihre Bewerbung trotzdem abschließen, wenn Sie nicht über die erforderlichen Dokumente verfügen.<br/><b>Sie können jedoch erst handeln, wenn wir die erforderlichen Dokumente erhalten haben.<b/>",
        "header1": "Identitätsnachweis (Minimum requirement: $Logic)",
        "list1": "Wir benötigen Farbkopien vom originalen Personalausweis / Reisepass, der von der Behörde ausgestellt wurde. Zur Überprüfung benötigen wir die Vorder- und Rückseite der Karte.",
        "list1_new":"Wir benötigen eine klare und Farbkopie des Originalpasses, wobei alle vier Ecken sichtbar sind.",
        "header2": "Adressnachweis (Any $Logic of the following options)",
        "list2": "<p>&nbsp;&nbsp;&nbsp;&nbsp;Betriebskostenrechnung (Wasser/Strom/Gas) - ausgestellt innerhalb der letzten 3 Monate,<br>&nbsp;&nbsp;&nbsp;&nbsp;Kontoauszug, der in den letzten 3 Monaten ausgestellt wurde,<br>&nbsp;&nbsp;&nbsp;&nbsp;Wir können Wohnregister / Grundbuchauszüge, einschließlich chinesischem Hukou akzeptieren - diese unterliegen jedoch einer Überprüfung.<br>&nbsp;&nbsp;&nbsp;&nbsp;Ein aktueller Mietvertrag und eine dazugehörige Betriebskostenabrechnung (Gas/Wasser/Strom), die in den letzten 3 Monaten bezahlt wurde, müssen zur Verfügung gestellt werden.<br>&nbsp;&nbsp;&nbsp;&nbsp;Eine aktuelle Steuerrechnung, ausgestellt innerhalb der letzten 6 Monate.<br>&nbsp;&nbsp;&nbsp;&nbsp;Eine Festnetz-Telefonrechnung, ausgestellt innerhalb der letzten 3 Monate.<br>&nbsp;&nbsp;&nbsp;&nbsp;*Wir akzeptieren nicht: Handy-Rechnungen, Kreditkarten-Abrechnungen oder Rechnungen für mobile Dienste; Einnahmen aus Versicherungen; Rechnungen für gekaufte Waren/Dienstleistungen.</p>",
        "strongTxt":"<strong>Im Rahmen unserer regulatorischen Anforderungen benötigen wir möglicherweise zusätzliche Dokumente für Ihre Bewerbung.</strong>"
      }
    },
    "isHaveCitizen": "Sind Sie Bürger der Vereinigten Staaten von Amerika?",
    "CitizenSelect": {
      "Y": "Ja",
      "N": "Nein"
    },
    "citizen_Tip":"Leider können wir kein Konto für US-Bürger eröffnen",
    "isDualCitizenship": "Sind Sie in einem anderen Land als dem Steuerland ansässig, in dem Sie wohnen?",
    "DualCitizenshipSelect": {
      "Y": "Ja",
      "N": "Nein"
    },
    "Dual_Nationality":"Land",
    "IS_Politically_Person": "Sind Sie eine politisch exponierte Person? ",
    "IS_Politically_Exposed":'Eine politisch exponierte Person ist eine natürliche Person, die in der Republik oder in einem anderen Land mit bedeutenden öffentlichen Aufgaben betraut ist oder war,ein unmittelbarer enger Verwandter dieser Person ist sowie eine Person sein kann, von der bekannt ist, dass sie mit dieser Person eng verbunden ist:<br/>Voraussetzung dafür ist, dass für die Zwecke der vorliegenden Definition "bedeutende öffentliche Funktion" eine der folgenden öffentlichen Funktionen begleitet wird:<br/>　a)Staatsoberhäupter, Regierungschefs, Minister und stellvertretende Minister;<br/>　b)Mitglieder des Parlaments oder ähnlicher gesetzgebender Körperschaften;<br/>　c)Mitglieder der Leitungsorgane einer politischen Partei;<br/>　d)Mitglieder von Obersten Gerichten, Verfassungsgerichten oder anderen hochrangigen Justizorganen,gegen deren Entscheidungen außer in Ausnahmefällen keine weitere Berufung eingelegt werden kann;<br/>　e)Mitglieder der Rechnungshöfe oder der Organe der Zentralbanken;<br/>　f)Botschafter, Sonderbeauftragte und hochrangige Offiziere der Streitkräfte;<br/>　g)Mitglieder der Verwaltungs-, Leitungs- oder Aufsichtsorgane von Staatsunternehmen;<br/>　h)Direktoren, stellvertretende Direktoren und Mitglieder des Vorstands oder gleichwertige Funktionen einer internationalen Organisation;<br/>　i)Bürgermeister: Unter der Voraussetzung, dass keine öffentliche Funktion im Sinne des Buchstaben a) bis<br/>　i)ist so zu verstehen, dass sie sich auf Mittlere- oder Nachwuchsbeamte bezieht;<br/>Unter der weiteren Voraussetzung, dass "nahe Verwandte einer politisch exponierten Person" Folgendes einschließen:<br/>　a)der Ehegatten oder eine Person, die einem Ehegatten gleichgestellt ist, eine politisch exponierte Person ist;<br/>　b)die Kinder und ihre Ehepartner oder Personen, die einem Ehepartner gleichgestellt sind, eine politisch exponierte Person ist;<br/>　c)die Eltern einer politisch exponierten Person; vorausgesetzt, dass auch weiterhin "Personen,die als enge Vertraute einer politisch exponierten Person bekannt sind", eine natürliche Person sind:<br/>　a)die bekanntermaßen ein gemeinsames wirtschaftliches Eigentum an juristischen Personen oder rechtlichen Vereinbarungen oder anderen engen Geschäftsbeziehungen mit einer politisch exponierten Person hat;<br/>　b)die das alleinige wirtschaftliche Eigentum an einer juristischen Person oder einer rechtsgültigen Vereinbarung hat,von der bekannt ist, dass sie für den tatsächlichen Nutzen einer politisch exponierten Person gegründet wurde.<br/>',
    "IS_Politically_Person_Select": {
      "Y": "Ja",
      "N": "Nein"
    },
  },
  "financialDetails": {
    "Emp_Status": "Bitte auswählen",
    "employmentStatusSelect": {
      "b": "Angestellt",
      "a": "Selbstständig",
      "c": "Student",
      "e": "Im Ruhestand",
      "d": "Arbeitslos"
    },
    "Freelance_OwnACompany": "Freiberuflich / Eigentümer eines Unternehmens",
    "Freelance_OwnACompany_select": {
      "0": "Freiberuflich",
      "1": "Eigentümer eines Unternehmens"
    },
    "Position": "Position",
    "FD_Position_select": {
      "0": "Top-Manager, z.B. CEO, CFO, CIO",
      "1": "Senior Manager",
      "2": "Allgemeiner Manager / Mittleres Management",
      "3": "Supervisor",
      "4": "Sachbearbeiter",
      "5": "Mitarbeiter",
      "6": "Junior",
      "7": "Anderer (bitte angeben)"
    },
    "Employer": "Firmenname",
    "Biz_Nature": "Art des Geschäfts",
    "financialRegulator": "Ist Ihr Arbeitgeber von der FCA oder einer anderen Finanzaufsichtsbehörde zugelassen?",
    "financialRegulatorSelect": {
      "Y": "Ja",
      "N": "Nein"
    },
    "Industry_Sector": "Branche/Sektor",
    "Industry_Sector_select": {
      "0": "Buchhaltung",
      "1": "Werbung/Medien",
      "2": "Computer/Internet/Kommunikation/Elektronik",
      "3": "Ausbildung/Training",
      "4": "Energie/Rohstoffe",
      "5": "Finanzdienstleistungen (Finanzen/Bank/Versicherung)",
      "6": "Regierung/gemeinnütziges Unternehmen",
      "7": "Personalwesen",
      "8": "Rechtswesen",
      "9": "Marketing",
      "10": "Logistik/Transport",
      "11": "Pharmaindustrie/Medizin",
      "12": "Professionelle Dienstleistungen",
      "13": "Immobilien/Bau",
      "14": "Dienstleistungsbranche",
      "15": "Handel/Produktion/Vertrieb",
      "16": "Andere (bitte angeben)"
    },
    "Annual_Income": "Jährliches Einkommen",
    "Annual_Income_word":"dazu zählen alle Einkünfte einschließlich Löhne, Renten, Zinsen, Dividenden, Mieteinnahmen usw.",
    "Total_Saving_Investments": "Alle Ersparnisse & Investitionen",
    "Total_Saving_word": "dazu zählen alle Bank- oder Brokerage-Konten, Zertifikate, Anleihen, Investitionen in den Geldmarkt usw.",
    "Total_Saving_Investments_select": {
      "0": "Mehr als US$500.000",
      "1": "US$200,000-US$499,999",
      "2": "US$100,000-US$199,999",
      "3": "US$50,000-US$99,999",
      "4": "US$25,000-US$49,999",
      "5": "US$10,000-US$24,999",
      "6": "US$2,000-US$9,999",
      "7": "Weniger als US$2.000"
    },
    "liquidNetWorth": "Verfügbares Eigenkapital (ohne privaten Wohnsitz)",
    "financialPortfolio": "Wert Ihres Finanzportfolios",
    "annualIncomeSelect": {
      "0": "Mehr als US$200.000",
      "1": "US$100,000-US$199,999",
      "2": "US$50,000-US$99,999",
      "3": "US$25,000-US$49,999",
      "4": "US$10,000-US$24,999",
      "5": "Weniger als US$10,000"
    },
    "fundsSource": "Herkunft dieser Geldmittel",
    "fundsSourceSelect": {
      "0": "Keine",
      "1": "Familien- und Partnereinkommen",
      "2": "Regierungsleistung",
      "3": "Darlehen/Kredit",
      "4": "Rente",
      "5": "Immobilieneinkünfte",
      "6": "Andere (bitte angeben)"
    },
    "Funds_Source": "Andere Einnahmequelle",
    "Intend_Deposit": "Wie viel beabsichtigen Sie einzuzahlen?",
    "intendDepositSelect": {
      "0": "Mehr als US$100.000",
      "1": "US$80,000 – US$99,999",
      "2": "US$50,000 – US$79,999",
      "3": "US$25,000 – US$49,999",
      "4": "US$10,000 – US$24,999",
      "5": "Weniger als US$10,000"
    },
    "Other_Industry_Sector": "Andere Branch / anderer Sektor",
    "Other_Position": "Andere Position",
    "Other_Biz_Nature": "Andere Art des Geschäfts",
    "Other_Funds_Source": "Andere Einnahmequelle",
    "Afford_To_Lose_Error":"CFDs sind Produkte mit hohem Risiko, Sie sollten nur mit Geld handeln, welches Sie sich leisten können zu verlieren.",
    "Afford_To_Lose":"Können Sie es sich leisten, die Gelder die Sie investieren wollen zu verlieren?",
    "Afford_To_Lose_Select": {
      "Y": "Ja",
      "N": "Nein"
    },
    "Open_Trading_Account":"Warum möchten Sie ein Handelskonto bei ATFX eröffnen?",
    "Open_Trading_Account_Select": {
      "0": "Kurz- bis mittelfristige Spekulationen an den Finanzmärkten",
      "1": "Kurz- bis mittelfristige Absicherung gegen Risiken bestehender Investitionen",
      "2": "Kurz- bis mittelfristige Spekulationen an den Finanzmärkten und Absicherung gegen Engagements bei bestehenden Investitionen"
    },
     "ATFX_Client_Pro":"ATFX betrachtet seine Produkte für Kunden geeignet, welche die oben genannten Zielen verfolgen. Bitte verzichten Sie auf eine Anmeldung, wenn Ihre Ziele von den oben genannten abweichen.",
    "Annual_Income_Total":"Bitte geben Sie Ihr aktuelles Jahreseinkommen an",
    "Saving_Investments_Money":"Bitte geben Sie Ihre aktuelles Sparvermögen & Investitionen an",
  },
  "Experience": {
    "experienceLabel": "In welchem Umfang haben Sie in den letzten drei Jahren die folgenden Finanzinstrumente gehandelt, bei denen Sie Ihre eigenen Handelsentscheidungen getroffen haben?",
    "Futures_Options": "Futures / Optionen",
    "Futures_Options_select": {
      "0": "Mehr als 40 Mal",
      "1": "15 bis 40 Mal",
      "2": "1 bis 15 Mal",
      "3": "Nie"
    },
    "CFDs_Spread_Bets": "CFDs, FX-Derivate oder Spread-Wetten",
    "CFDs_Spread_Bets_select": {
      "0": "Mehr als 40 Mal",
      "1": "15 bis 40 Mal",
      "2": "1 bis 15 Mal",
      "3": "Nie"
    },
    "Derivative_Trade_over2": "Haben Sie in den letzten zwölf Monaten mindestens zwei Trades pro Quartal hinsichtlich Spot FX / CFDs / Optionen / Futures oder Spread-Wetten gemacht, bei denen Sie Ihre eigenen Handelsentscheidungen getroffen haben?",
    "Derivative_Trade_over2_select": {
      "b": "Ja",
      "a": "Nein"
    },
    "Derivative_Trade_over40": "Haben Sie innerhalb der letzten drei Jahre in einem Zeitraum von zwölf Monaten mindestens 40 Trades hinsichtlich Spot FX / CFDs / Optionen / Futures oder Spread-Wetten gemacht?",
    "Derivative_Trade_over40_select": {
      "b": "Ja",
      "a": "Nein"
    },
    "Average_Annual_Investment":"Wie hoch war das durchschnittliche jährliche Anlagevolumen Ihrer vergangenen Transaktionen in den von Ihnen ausgewählten Finanzprodukten?",
    "Average_Annual_Investment_select": {
      "0": "Ich habe noch nie investiert.",
      "1": "Weniger als $500 ",
      "2": "Zwischen $500 und $2.500",
      "3": "Zwischen 2.500 $ und 10.000 $.",
      "4": "Über $10.000"
    },
    "Average_Leverage_Level":"Wie hoch war der durchschnittliche Hebel, den Sie für den Handel mit den von Ihnen ausgewählten Finanzprodukten verwendet haben?",
    "Average_Leverage_Level_select": {
      "0": "Ich habe noch nie einen Hebel benutzt.",
      "1": "Bis zu 1:10",
      "2": "Zwischen 1:10 und 1:25",
      "3": "Zwischen 1:25 und 1:50",
      "4": "Zwischen 1:50 und 1:100",
      "5": "Mehr als 1:100"
    }
  },
  "Knowledge": {
    "DT_Work_Experience": "Haben Sie schon einmal in einer Position gearbeitet, die Kenntnisse über den Handel gehebelter Derivate erforderte?",
    "DT_Work_Experience_select": {
      "txt1": "Ja",
      "txt2": "Nein",
      "subTxt1": "Ich habe mindestens 3 Jahre Berufserfahrung",
      "subTxt2": "Ich habe weniger als 3 Jahre Berufserfahrung, aber mindestens ein Jahr Erfahrung hinsichtlich des Investierens in eigenem Namen."
    },
    "DT_Qualification": "Haben Sie einen Abschluss gemacht, der Ihnen ein Verständnis über den Handel gehebelter Derivate vermittelt hat?",
    "DT_Qualification_select": {
      "txt1": "Ja",
      "txt2": "Nein",
      "subTxt1": "Ich habe eine berufliche Qualifikation oder einen Abschluss wie beispielsweise CFA, MBA, BSC oder MA",
      "subTxt2": "Ich habe einen Abschluss im Bereich Finanzen, Wirtschaft, Buchhaltung oder in einem ähnlichen Bereich"
    },
    "K_Sell_Position": "Wenn Sie 1 Lot Gold (XAUUSD) zu einem Preis von 1.200 verkaufen und der Markt sich Richtung 1.300 bewegt, würden Sie Geld verdienen oder verlieren?",
    "K_Sell_Position_b": "Wenn Sie 1 Lot Gold XAUUSD.sb zu einem Preis von 1.200 verkaufen und der Markt sich Richtung 1.300 bewegt, würden Sie Geld verdienen oder verlieren?",
    "K_Sell_Position_select": {
      "0": "Verlieren",
      "1": "Verdienen"
    },
    "Closing_Order": "Um zu verhindern, dass Ihr Konto mehr als den von Ihnen vorab festgelegten Betrag verliert. Würden Sie Ihren Verlust begrenzen, indem Sie einen Stop Loss oder einen Take Profit platzieren?",
    "Closing_Order_select": {
      "0": "Stop Loss",
      "1": "Take Profit"
    },
    "K_Profit_Change": "Verstehen Sie, dass ein größerer Hebel zu einem höheren Risiko für Ihr Kapital führt, wenn Sie gehebelte CFD-Produkte handeln?",
    "K_Profit_Change_b": "Verstehen Sie, dass ein größerer Hebel zu einem höheren Risiko für Ihr Kapital führt, wenn Sie gehebelte CFD-Produkte/Spread-Wetten handeln?",
    "K_Profit_Change_select": {
      "0": "Ich verstehe es",
      "1": "Ich verstehe es nicht"
    },
    "K_Margin": "Was wäre die erforderliche Margin für 1 Lot (100.000) USD/JPY, wenn Ihr Hebel 1:20 ist?",
    "K_Margin_select": {
      "0": "USD 5,000",
      "1": "USD 50,000",
      "2": "USD 100,000"
    }
  },
  "Acknowledgements": {
    "A1": "Ich bestätige, dass die Ihnen zur Verfügung gestellten Informationen korrekt und vollständig sind und verpflichte mich, Sie zu benachrichtigen, wenn sich an diesen Informationen etwas ändert.",
    "A2": "Ich habe gelesen, verstanden und bin damit einverstanden, an die AT Global Markets Kundenvereinbarung gebunden zu sein, die mir zur Verfügung gestellt wurde.",
    "A2_txt": "die AT Global Markets Kundenvereinbarung",
    "A2_link": "<a href='https://www.atfx.com/uk/wp-content/uploads/standard-terms-uk-en.pdf' target='_blank'>die AT Global Markets Kundenvereinbarung</a>",
    "A3": "Ich habe die AT Global Markets Risikoaufklärung, die mir zur Verfügung gestellt wurde, gelesen, verstanden und stimme ihr zu.",
    "A3_txt": "die AT Global Markets Risikoaufklärung",
    "A3_link": "<a href='https://www.atfx.com/uk/wp-content/uploads/standard-terms-uk-en.pdf' target='_blank'>die AT Global Markets Risikoaufklärung</a>",
    "A4": "Ich habe die Richtlinie zur Orderausführung sowie die Richtlinie zur Beilegung von Streitigkeiten von AT Global Markets, die mir zur Verfügung gestellt wurde, gelesen, verstanden und akzeptiere sie.",
    "A4_txt": "die Richtlinie zur Orderausführung und zur Beilegung von Streitigkeiten von AT Global Markets",
    "A4_link": "<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Order%20Execution%20Policy%20EN%20-%20V10.18.pdf' target='_blank'>die Richtlinie zur Orderausführung</a> und <a href='https://www.atfx.com/uk/wp-content/uploads/conflict-of-interests-policy-uk-en.pdf' target='_blank'>zur Beilegung von Streitigkeiten von AT Global Markets</a>",
    "header": "Mit dem Ausfüllen dieses Antrags bestätigen Sie, dass Sie verstanden haben, dass FX und CFDs mit Margin gehebelte Produkte sind und ein hohes Risiko für Ihr investiertes Kapital darstellen. Sie bestätigen weiterhin, dass es in Ihrer Verantwortung liegt, Ihr Konto zu überwachen.",
    "age": "Sie bestätigen, dass Sie mindestens 18 Jahre alt sind;",
    "message": "Die in diesem Antrag zur Verfügung gestellten Informationen sind wahr und korrekt. Sie verpflichten sich, uns zu benachrichtigen, wenn sich an diesen Informationen etwas ändert.",
    "receive": {
      "text": "Sie haben Folgende Richtlinien und Dokumente gelesen, verstanden und stimmen ihnen zu:",
      "list": [
        "<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Standard%20Terms%20of%20Business%20EN%20-%20V08.18.pdf' target='_blank'>Allgemeinen Geschäftsbedingungen und der Risikohinweis</a>",
        "<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Order%20Execution%20Policy%20EN%20-%20V10.18.pdf' target='_blank'>Richtlinie zur Orderausführung</a>",
        "<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Privacy%20Notice%20EN%2031.08.pdf' target='_blank'>Datenschutzerklärung</a>",
        // "<a href='https://www.atfx.com/uk/wp-content/uploads/introducing-broker-disclosure-en.pdf' target='_blank'>Offenlegung von Indtroducing Broker</a>",
        "<a href='https://www.atfx.com/de/rechtliches' target='_blank'>wesentlichen Anlegerinformationen</a>"
      ]
    },
    "A_select": {
      "text": "Ich habe alle Bedingungen gelesen, verstanden und stimme ihnen zu.",
      "Y": "Ich habe alle Bedingungen gelesen, verstanden und stimme ihnen zu."
    },
    "checkboxTxt_A1": "Ich habe alle Bedingungen gelesen, verstanden und stimme ihnen zu.",
    "checkboxTxt_A2": "Ich verstehe, dass CFDs gehebelte Produkte sind und deren Performance volatil sein kann.",
    "checkboxTxt_A3": "Ich verstehe, dass es in meiner Verantwortung liegt, mein Konto zu überwachen und zu verwalten.",
    "checkboxTxt_A4": "Ich verstehe, dass es beim Handel mit gehebelten Produkten möglich ist, mehr als meine ursprüngliche Investition zu verlieren.",
    "Marketing_Email_Preference": "Ich bin damit einverstanden, Informationen von ATFX zu erhalten, die Marketingmaterial enthalten können.",
    "Marketing_automatically": "Ich verstehe, dass ich sofort den Erhalt von Marketingmitteilungen ablehnen kann, indem ich mich an den <a href='https://www.atfx.com/de/ueber-uns/kontakt' target='_blank'>Kundendienst</a> Kundendienst.",
    "Marketing_Email_Preference_select": {
      "Y": "Ja",
      "N": "Nein"
    },
    "Hear_ATFX": "Wie haben Sie von ATFX erfahren?",
    "OtherHearATFX": "Auf andere Weise",
    "hearATFXSelect": {
      "Recommendation": "Empfehlung",
      "SearchEngine": "Suchmaschine",
      "MediaAdvertising": "Werbung in den Medien",
      "Partnership": "Partnerschaft",
      "Other": "Andere"
    },
    "Parent_IB_Code": "Referrer Code",
    "Rec_Type": "Bitte auswählen",
    "recTypeSelect": {
      "AA1": "AA1",
      "AA2": "AA2",
      "AA3": "AA3",
      "A01": "A01",
      "A02": "A02",
      "A03": "A03",
      "A00": "A00",
      "NAN": "Kein Referrer"
    },
    "recGroup": "Referrer-Gruppe",
    "recGroupSelect": {
      "A": "A",
      "AA": "AA"
    }
  },
  "customErrMsg": {
    "fieldIsRequired": {
      "Gender": "Bitte auswählen",
      "OtherGender": "Anderes Geschlecht",
      "Title": "Bitte auswählen",
      "OtherTitle": "Anderer Titel",
      "First_Name": "Vorname",
      "Surname": "Nachnahme",
      "Email": "E-Mail-Adresse",
      "Email_Confirm": "E-Mail-Adresse bestätigen",
      "Lang": "Bitte auswählen",
      "Country": "Bitte auswählen",
      "MT4_Currency": "Bitte auswählen",
      "Account_Type": "Bitte auswählen",
      "Addr": "Adresse",
      "Addr2": "Adresszeile 2",
      "City": "Stadt",
      "Postcode": "Postleitzahl",
      "Building_Name": "Hausnummer/Gebäudename",
      "Street": "Straße",
      "Province": "Provinz",
      "Birth_Date_Year": "Geburtsdatum",
      "Birth_Date_Month": "Geburtsdatum",
      "Birth_Date_Day": "Geburtsdatum",
      "Nationality": "Staatsangehörigkeit",
      "isHavePass": "Bitte auswählen",
      "NAT_ID": "Reisepassnummer",
      "Phone": "Telefon",
      "Doc_Type": "Bitte auswählen",
      "Doc_No": "ID-Nr.",
      "Addr_Country": "Bitte auswählen",
      "Bank_Card_No": "Banknummer",
      "Bank": "Bitte auswählen",
      "OtherBank": "Andere Banken",
      "Beneficiary_Name": "Name des Begünstigten",
      "Branch_Name": "Name der Filiale",
      "Bank_Addr": "Adresse der Filiale",
      "Branch_Province": "Bundesland der Filiale",
      "Branch_City": "Stadt der Filiale",
      "FD_Emp_Status": "Bitte auswählen",
      "FD_Position": "Position",
      "FD_Employer": "Name des Unternehmens",
      "FD_Biz_Nature": "Bitte geben Sie die Geschäftsattribute ein",
      "FD_FCA_AUTH": "Bitte auswählen",
      "FD_Annual_Income": "Bitte auswählen",
      "FD_Liquid_Net_Worth": "Bitte auswählen",
      "FD_Portfolio_Value": "Bitte auswählen",
      "FD_Funds_Source": "Bitte auswählen",
      "FD_Funds_Other": "Bitte auswählen",
      "E_Forex_Exp": "Bitte auswählen",
      "E_Forex_Trade_No": "Bitte auswählen",
      "E_Derivative_Exp": "Bitte auswählen",
      "E_Derivative_Trade_No": "Bitte auswählen",
      "E_Equity_Exp": "Bitte auswählen",
      "E_Equity_Trade_No": "Bitte auswählen",
      "K_A": "Bitte auswählen",
      "K_A_Detail": "Details",
      "K_B": "Bitte auswählen",
      "K_B_Detail": "Details",
      "K_C": "Bitte auswählen",
      "K_C_Detail": "Details",
      "K_D": "Bitte auswählen",
      "K_E": "Bitte auswählen",
      "K_F": "Bitte auswählen",
      "K_G": "Bitte auswählen",
      "K_H": "Bitte auswählen",
      "A1": "Bitte auswählen",
      "A2": "Bitte auswählen",
      "A3": "Bitte auswählen",
      "A4": "Bitte auswählen",
      "checkList": "Bitte auswählen",
      "Emp_Status": "Bitte auswählen",
      "Freelance_OwnACompany": "Bitte auswählen",
      "Industry_Sector": "Bitte auswählen",
      "Position": "Bitte auswählen",
      "Employer": "Name des Unternehmens",
      "Biz_Nature": "Bitte geben Sie die Geschäftsattribute ein",
      "Annual_Income": "Bitte auswählen",
      "Total_Saving_Investments": "Bitte auswählen",
      "Funds_Source": "Bitte auswählen",
      "Intend_Deposit": "Bitte auswählen",
      "Other_Industry_Sector": "Andere Branche / anderer Sektor",
      "Other_Position": "Andere Position",
      "Other_Biz_Nature": "Andere Art des Geschäfts",
      "Other_Funds_Source": "Andere Einnahmequelle",
      "Futures_Options": "Bitte auswählen",
      "CFDs_Spread_Bets": "Bitte auswählen",
      "Derivative_Trade_over2": "Bitte auswählen",
      "Derivative_Trade_over40": "Bitte auswählen",
      "DT_Work_Experience": "Bitte auswählen",
      "DT_Qualification": "Bitte auswählen",
      "K_Sell_Position": "Bitte auswählen",
      "Closing_Order": "Bitte auswählen",
      "K_Profit_Change": "Bitte auswählen",
      "K_Margin": "Bitte auswählen",
      "IBAN_Code": "IBAN",
      "Hear_ATFX": "Bitte auswählen",
      "OtherHearATFX": "Bitte geben Sie folgendes ein:",
      "Rec_Type": "Bitte auswählen",
      "Parent_IB_Code": "Referrer Code",
      "isHaveCitizen":"Bitte auswählen",
      "isDualCitizenship":"Bitte auswählen",
      "Dual_Nationality":"Bitte auswählen",
      "IS_Politically_Person":"Bitte auswählen",
      "Afford_To_Lose":"Bitte auswählen",
      "Open_Trading_Account":"Bitte auswählen",
      "Annual_Income_Total":"Bitte eingeben",
      "Saving_Investments_Money":"Bitte eingeben",
    }
  },
  "errors": {
    "fieldIsRequired": "E-Mail-Adresse",
    "invalidFormat": "Ungültiges Format!",
    "numberTooSmall": "Die Nummer ist zu kurz! Mindestens: {0}",
    "numberTooBig": "Die Nummer ist zu lang! Maximal: {0}",
    "invalidNumber": "Ungültige Nummer",
    "textTooSmall": "Die Länge des Textes ist zu kurz! Aktuell: {0}, Mindestens: {1}",
    "textTooBig": "Die Länge des Textes ist zu lang! Aktuell: {0}, Maximal: {1}",
    "thisNotText": "Dies ist kein Text!",
    "thisNotArray": "Dies ist keine Reihe!",
    "selectMinItems": "Wählen Sie mindestens {0} Elemente aus!",
    "selectMaxItems": "Wählen Sie maximal {0} Elemente aus!",
    "invalidDate": "Ungültiges Datum!",
    "dateIsEarly": "Das Datum ist zu früh! Aktuell: {0}, Frühestens: {1}",
    "dateIsLate": "Das Datum ist zu spät! Aktuell: {0}, Spätestens: {1}",
    "invalidEmail": "Die E-Mail-Adresse ist nicht verfügbar!",
    "invalidURL": "Üngültige URL!",
    "invalidCard": "Ungültiges Kartenformat!",
    "invalidCardNumber": "Ungültige Kartennummer!",
    "invalidTextContainNumber": "Ungültiger Text! Er darf keine Zahlen oder Sonderzeichen enthalten",
    "invalidTextContainSpec": "Ungültiger Text! Er darf keine Sonderzeichen enthalten",
    "incorrectComfirm": "Die zwei Eingaben sind inkonsistent",
    "invalidBirthDate": "Es können nur Anträge von Personen akzeptiert werden, die 18 bis 69 Jahre alt sind",
    "invalidParentClnID": "Bitte geben Sie eine Nummer ein, die weniger als 12 Ziffern hat!",
    "docImgFrontSizeLimit": "ID-Bild (Vorderseite) darf 2 MB nicht überschreiten",
    "docImgBackSizeLimit": "ID-Bild (Rückseite) darf 2 MB nicht überschreiten",
    "imgSizeLimit": "Das Dokument für den Adressnachweis darf 2 MB nicht überschreiten.",
    "bankCardNoTopTwo": "Die ersten beiden Ziffern der Bankkarte sind nicht richtig",
    "bankCardNoLnegth": "Bitte geben Sie eine Zahl von 16-19 ein",
    "dayErrors1": "Das Jahr ist ein Schaltjahr und es gibt keinen Tag",
    "dayErrors2": "In diesem Jahr gibt es den Tag nicht",
    "dayErrors3": "Der Tag existiert in diesem Monat nicht",
    "emailError": "Die E-Mail-Adresse ist nicht verfügbar",
    "DocTypeNoError": "Die ID-Nr. ist illegal",
    "DocFrontImg": "Bitte laden Sie das ID-Bild (Vorderseite) hoch",
    "DocBackImg": "Bitte laden Sie das ID-Bild (Rückseite) hoch",
    "ProofofAddress": "Bitte laden Sie den Adressnachweis hoch",
    "Doc_No": "Bitte geben Sie die ID-Nr. ein",
    "Phone": "Telefon",
    "Bank_Card_No": "Banknummer",
    "Birth_Date_Second": "Geburtsdatum",
    "phoneError": "Das Format der Telefonnummer ist falsch",
    "bankNumError": "Das Format der Banknummer ist falsch",
    "numType": "Bitte geben Sie die Nummer ein",
    "bankCodeError": "Das Format des Codes hinsichtlich der Bank-IBAN ist falsch",
  },
  "messages": {
    "fieldsWillBeReset": "Alle Eingaben werden zurückgesetzt, bitte bestätigen.",
    "completeTip1": "Bitte überprüfen Sie Ihre E-Mails. Vielen Dank.",
    "completeTip2": "Abgeschlossen! Vielen Dank.",
    "noCompleteTip": "Entschuldigung, Ihre Dateneingaben sind falsch und der obige Vorgang ist fehlgeschlagen.",
    "emailAndDocInvalid": "Die E-Mail-Adresse wurde bereits verwendet",
    "phoneAndDocInvalid": "Die Telefonnummer wurde bereits verwendet",
    "IBCodeInvalid": "Der Referrer Code ist falsch",
    "invalidBankCardNo": "Die Nummer der Bankkarte ist falsch. Bitte überprüfen Sie diese vor dem Abschicken",
    "beneficiaryName": "Bitte verwenden Sie den bei der Bank hinterlegten Kontonamen, Dritte sind nicht erlaubt.",
    "employerName": "Wir werden Ihren Arbeitgeber nicht kontaktieren",
    "errors": "Netzwerkfehler",
    "unSelect": "Bitte auswählen",
    "selectEmpStatusTip": "Ihr Beschäftigungsstatus zeigt, dass Sie im Ruhestand/ein Student/arbeitslos sind. Der Handel mit Devisen (Forex) und Differenzkontrakten (CFDs) ist hoch spekulativ und birgt ein hohes Risiko für Ihr Kapital.</div><div style='padding-top:10px;'>Um Ihre unmittelbaren Interessen zu schützen, überprüfen wir Ihre Eignung für die Produkte, die wir anbieten, basierend auf den von Ihnen zur Verfügung gestellten Belege, die das in Ihrem Antrag erwähnte Spar-/Erbschaftsguthaben bestätigen.</div>"
  },
  "ModalMsg": {
    "showModal": {
      "content": "Aufgrund der Informationen, die Sie bei Ihrem AT Global Markets (UK) Limited Kundenkontoantrag angegeben haben, müssen wir Sie darüber informieren, dass der Handel mit CFDs und FX mit Margin möglicherweise nicht für Sie geeignet ist. Der Handel mit Hebel birgt ein hohes Risiko und kann zu Verlusten führen, die höher sind als Ihre ursprüngliche Einzahlung. Das Unternehmen bietet seinen Kunden ausschließlich eine Dienstleistung zur Ausführung von Trades und Sie müssen sich beim Handel dieser Märkte vollständig auf Ihre eigenen Fähigkeiten und Ihr Urteilsvermögen verlassen. <br/><br/><b>Bitte beachten Sie: AT Global Markets (UK) Limited bietet Demokonten, mit deren Hilfe Sie den Handel unter realistischen Marktbedingungen üben können. Das Unternehmen empfiehlt Ihnen, dies zu versuchen, bevor Sie mit echtem Geld handeln. </b><br/><br/>Wenn Sie dennoch ein Kundenkonto bei AT Global Markets (UK) Limited eröffnen möchten, bestätigen Sie dies bitte, indem Sie die nachfolgende Erklärung akzeptieren.",
      "checkboxTxt":"Ich verstehe, dass der Handel mit CFDs und FX mit Margin ein hohes Risiko birgt und zu Verlusten führen kann, die größer sind als meine ursprüngliche Einzahlung. Ich bin in der Lage, die Risiken einzuschätzen und möchte meinen Antrag auf Kontoeröffnung fortsetzen.",
      "errorsTxt": "Bitte auswählen",
      "btn": "Bestätigen"
    },
    "showAlert": {
      "title": "Tipp:",
      "submitBtnTxt": "Bestätigen",
      "cancleBtnTxt": "Abbrechen",
      "confirmBtnTxt": "Bestätigen"
    }
  },
  "ratesModalMsg": {
    "p3_1": "WARNUNG - DER MARGIN-SATZ ÄNDERT SICH FÜR ALLE PRIVATKUNDEN",
    "p3_2": "Sehr geehrter Antragsteller,",
    "p3_2_1": "",
    "p3_3": "Bitte beachten Sie, dass aufgrund der Änderungen durch die Europäische Wertpapier- und Marktaufsichtsbehörde (ESMA) für Privatkunden, für alle neuen ATFX-Kunden ab dem 2. Juli die folgenden Margin-Sätze gelten werden. ",
    "p3_4": "Zu diesen Änderungen zählt eine Obergrenze für die Größe des Hebels, die Privatkunden angeboten werden darf.",
    "p4_1": "Major FX: Währungspaare, die zwei der folgenden Währungen enthalten: USD, EUR, JPY, GBP, CAD, CHF - 3,33% (Hebel 30:1)",
    "p4_2": "Minor FX: Alle anderen Währungspaare - 5% (Hebel 20:1)",
    "p4_3": "Major Indizes: UK100, FRA40, ESP35, US30, SPX500, NAS100, JP225, AUS200 - 5% (Hebel 20:1)",
    "p4_4": "Gold: 5% (Hebel 20:1)",
    "p4_5": "Rohstoffe: 10% (Hebel 10:1)",
    "p5_1": "Schutz vor negativem Kontostand",
    "p5_2": "Die ESMA hat eine neue Regel eingeführt, um sicherzustellen, dass alle Privatkunden-Trader niemals mehr als das auf Ihrem Konto verfügbare Geld verlieren können. Wenn Ihr Guthaben negativ wird, ist ATFX verpflichtet, Ihr Guthaben auf Null zu stellen - ohne Kosten für Sie als Kunden.",
    "p5_3": "50%-Margin-Glattstellungsregel",
    "p5_4": "ATFX bietet allen Kunden bereits die 50%-Margin-Glattstellungsregel",
    "p5_5": "Wenn Sie Ihren Antrag abschließen und ein ATFX-Konto für Privatkunden eröffnen möchten, kreuzen Sie bitte das untenstehende Kästchen an.",
    "p5_6": "Ich nehme die neuen Bestimmungen für Privatkunden zur Kenntnis und stimme ihnen zu",
    "p6_2": "Bitte stimmen Sie zu",
    "btnText": "ABSCHICKEN"
  },
  "verifyMsg": {
    "phone_exist": "Diese Telefonnummer wurde bereits verwendet, bitte verwenden Sie eine alternative Telefonnummer.",
    "email_exist": "Diese E-Mail-Adresse wurde bereits verwendet. Bitte verwenden Sie eine alternative E-Mail-Adresse.",
    "phoneAndemail_exist": "Die Telefonnummer und E-Mail-Adresse wurde bereits verwendet. Bitte verwenden Sie alternative Telefonnummern und E-Mail-Adressen.",
  }
}



// WEBPACK FOOTER //
// ./src/lang/de.js